export default "__VITE_ASSET__C5qcr19p__"